export default __webpack_public_path__ + "static/8327trguyw-7c9e3892e1a29631cae0ae738d99d43b.jpg";